import { render, staticRenderFns } from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=template&id=aa64fe24&scoped=true"
import script from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=style&index=0&id=aa64fe24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa64fe24",
  null
  
)

export default component.exports